import { graphql } from 'gql';

export const deleteBimOrderGql = graphql(`
    mutation bimRemoveWorkOrder($workOrderId: Long!) {
        bimRemoveWorkOrder(workOrderId: $workOrderId) {
            id
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);
